(function () {
  'use strict';

  function quantize(v, step) { return Math.round(v / step) * step; }

  function colorDistance(a, b) {
    return Math.sqrt(
      Math.pow(a[0] - b[0], 2) +
      Math.pow(a[1] - b[1], 2) +
      Math.pow(a[2] - b[2], 2)
    );
  }

  function toHex(rgb) {
    return '#' + rgb.map(function (v) {
      return Math.min(255, Math.max(0, v)).toString(16).padStart(2, '0');
    }).join('').toUpperCase();
  }

  function extractDominantColors(img, count, callback) {
    var canvas = document.createElement('canvas');
    var size   = 120;
    canvas.width  = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, size, size);

    var data  = ctx.getImageData(0, 0, size, size).data;
    var map   = {};
    var step  = 20; // quantisation step — smaller = more precise

    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i+1], b = data[i+2], a = data[i+3];
      if (a < 128) continue;

      var brightness = (r + g + b) / 3;
      var saturation = Math.max(r,g,b) - Math.min(r,g,b);

      // skip near-whites, near-blacks and very grey/desaturated pixels
      if (brightness > 235 || brightness < 20) continue;
      if (saturation < 18) continue;

      var qr = quantize(r, step);
      var qg = quantize(g, step);
      var qb = quantize(b, step);
      var key = qr + ',' + qg + ',' + qb;
      map[key] = (map[key] || 0) + 1;
    }

    // Sort by frequency, pick most distinct colours
    var sorted = Object.keys(map).sort(function (a, b) { return map[b] - map[a]; });
    var chosen = [];

    for (var s = 0; s < sorted.length && chosen.length < count; s++) {
      var parts = sorted[s].split(',').map(Number);
      var distinct = true;
      for (var c = 0; c < chosen.length; c++) {
        if (colorDistance(parts, chosen[c]) < 55) { distinct = false; break; }
      }
      if (distinct) chosen.push(parts);
    }

    callback(chosen.map(function (rgb) { return toHex(rgb); }));
  }

  function buildPalette(hexColors) {
    var container = document.getElementById('ff-color-palette');
    if (!container) return;
    container.innerHTML = '';

    hexColors.forEach(function (hex) {
      var wrap  = document.createElement('div');
      wrap.className = 'ff-cp-item';

      var dot = document.createElement('button');
      dot.className  = 'ff-cp-dot';
      dot.style.background = hex;
      dot.title = 'Click to copy ' + hex;
      dot.setAttribute('aria-label', hex);
      dot.addEventListener('click', function () {
        navigator.clipboard && navigator.clipboard.writeText(hex);
        dot.classList.add('ff-cp-copied');
        setTimeout(function () { dot.classList.remove('ff-cp-copied'); }, 1200);
      });

      var label = document.createElement('span');
      label.className   = 'ff-cp-hex';
      label.textContent = hex;

      wrap.appendChild(dot);
      wrap.appendChild(label);
      container.appendChild(wrap);
    });

    container.hidden = false;
  }

  function init() {
    var container = document.getElementById('ff-color-palette');
    var productImg = document.getElementById('product-image');
    if (!container || !productImg) return;

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      extractDominantColors(img, 3, buildPalette);
    };
    img.onerror = function () { container.hidden = true; };

    // use a clean URL without width transforms to avoid CORS issues
    var src = productImg.src.replace(/\?.*$/, '') + '?width=300';
    img.src = src;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
